module.exports = __webpack_public_path__ + "static/media/cq_ok b.a0c2732b.svg";